import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { Formik, Form as FormikForm, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axiosWrapper from '../../../../utils/api';
import { API_URL } from '../../../../utils/apiUrl';
import { useSelector } from 'react-redux';
import '../Groups.scss';

const PostPaymentModal = ({ show, onHide, totalDue, groupId, onPaymentSuccess }) => {
    const { userToken } = useSelector((state) => state.auth);

    // Yup schema to ensure paymentAmount is a positive number and not greater than totalDue.
    const validationSchema = Yup.object().shape({
        paymentAmount: Yup.number()
            .required('Payment amount is required')
            .positive('Amount must be positive')
            .max(totalDue, `Cannot exceed due amount of $${totalDue.toFixed(2)}`)
    });

    const handleSubmit = async (values, { setSubmitting, setErrors }) => {
        try {
            // API call to post payment.
            const response = await axiosWrapper(
                'post',
                `${API_URL.POST_PAYMENT_INVOICE_BY_ID(groupId)}`,
                { paymentAmount: values.paymentAmount },
                userToken
            );
            if (response?.success) {
                onPaymentSuccess();
                onHide();
            } else {
                setErrors({ submit: response.message || 'Payment failed' });
            }
        } catch (error) {
            setErrors({ submit: error.message || 'Payment failed' });
        }
        setSubmitting(false);
    };

    return (
        <Modal show={show} onHide={onHide} centered backdrop="static" className="post-payment-modal">
            <Modal.Header closeButton>
                <Modal.Title>Post Payment</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="total-due">
                    <p>Total Due Amount:</p>
                    <h3>${totalDue.toFixed(2)}</h3>
                </div>
                <Formik
                    initialValues={{ paymentAmount: '' }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ isSubmitting, errors }) => (
                        <FormikForm>
                            <Form.Group controlId="paymentAmount" className="mb-3 form-group">
                                <Form.Label>Enter Payment Amount</Form.Label>
                                <Field
                                    name="paymentAmount"
                                    type="number"
                                    placeholder="Enter amount"
                                    className="form-control"
                                />
                                <ErrorMessage name="paymentAmount" component="div" className="error-message" />
                            </Form.Group>
                            {errors.submit && <div className="error-message text-center">{errors.submit}</div>}
                            <div className="modal-footer-buttons">
                                <Button variant="secondary" onClick={onHide} disabled={isSubmitting}>
                                    Cancel
                                </Button>
                                <Button type="submit" className="submit-btn" disabled={isSubmitting}>
                                    {isSubmitting ? 'Processing...' : 'Submit Payment'}
                                </Button>
                            </div>
                        </FormikForm>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
};

export default PostPaymentModal;
